<!--
 * @Author       : 蔡韬
 * @Date         : 2020-09-01 10:15:31
 * @LastEditors  : 蔡韬
 * @LastEditTime : 2020-09-19 09:42:49
 * @FilePath     : \portal\src\views\account\components\register-tips.vue
-->
<template>
  <div>
    <el-dialog
      custom-class="register-tips-dialog"
      :title="$t(title)"
      :visible.sync="dialogVisible"
      :area="480"
      top="middle"
    >
      <div v-if="type === 0" class="dialog-content">
        <p>{{ $t('email_code_tips') }}</p>
        <div>
          <div>{{ $t('email_code_tips_1') }}</div>
          <div v-if="email">{{ '(' + $t('email_code_tips_2') + email + ')' }}</div>
          <div>{{ $t('fail_receive_email_reason_2') }}</div>
        </div>
      </div>
      <div v-else class="dialog-content">
        <div v-if="!isAuthenticationCodeRequired">
          <!-- 选填联系hik -->
          <div v-show="openRegisterCountryType === 1">
            {{ $t('auth_code_required_tip') }}
          </div>
          <!-- 选填联系经销商 -->
          <div v-show="openRegisterCountryType === 2">
            {{ $t('authentication_code_tip') }}
          </div>
        </div>
        <div v-else>
          <!-- 必填 联系hik -->
          <div v-if="!isSpecialTipCountry">{{ $t('auth_code_required_tip') }}</div>
          <div v-if="isSpecialTipCountry">
            <p :title="$t('us_auth_code_tips')">{{ $t('us_auth_code_tips') }}</p>
            <div class="us-auth-code-tips">
              <div :title="$t('us_auth_code_tips_1')">{{ $t('us_auth_code_tips_1') }}</div>
              <div :title="$t('us_auth_code_tips_2')">{{ $t('us_auth_code_tips_2') }}</div>
              <div :title="$t('us_auth_code_tips_3')">{{ $t('us_auth_code_tips_3') }}</div>
              <div :title="$t('us_auth_code_tips_4')">{{ $t('us_auth_code_tips_4') }}</div>
              <div :title="$t('us_auth_code_tips_5')">{{ $t('us_auth_code_tips_5') }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RegisterTips',
  props: {
    type: {
      type: Number, // [ 0:邮箱验证码 | 1:认证码]
      required: true
    },
    isSpecialTipCountry: {
      type: Boolean,
      required: true
    },
    email: {
      type: String, // 当前填写的邮箱地址
      default: null
    },
    openRegisterCountryType: {
      type: Number, // [ 0:邮箱验证码 | 1:认证码]
      default: null
    },
    isAuthenticationCodeRequired: {
      type: Boolean
    }
  },
  data() {
    return {
      dialogVisible: false // 弹出框是否展示标志
    };
  },
  computed: {
    title() {
      return this.type === 0 ? 'no_email_code' : 'get_auth_code';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/Common/styles/var';

.dialog-content {
  word-break: break-word;
  line-height: 24px;
  color: $font-color-9;
  padding: 0 20px 30px;

  .us-auth-code-tips {
    padding-left: 24px;
    line-height: 24px;
  }
}
</style>

<style lang="scss">
.app-mode .register-tips-dialog {
  width: calc(100% - 48px) !important;
  margin-left: 0 !important;
  left: 24px;

  .dialog-content {
    padding: 0;

    .us-auth-code-tips {
      padding-left: 0;
    }
  }
}
</style>
